"use strict";

// Adding event on button to show navbar
const menuBtn = document.querySelector(".open-btn-nav");
const menu = document.querySelector(".navbar");
const overlay = document.querySelector(".overlay");
const navItems = document.querySelectorAll(".link-navbar");
const Screenwidth = window.innerWidth;
console.log(Screenwidth);
const toggleNav = () => {
  if (Screenwidth < 1200) {
    menu.classList.toggle("active");
    overlay.classList.toggle("active");
  }
};

// Opens the navbar
menuBtn.addEventListener("click", toggleNav);

// Takes you to the desired section and removes the navbar
navItems.forEach((item) => item.addEventListener("click", toggleNav));

// Clicking overlay
overlay.addEventListener("click", function () {
  if (menu.classList.contains("active")) {
    toggleNav();
  }
});
